import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5b1c861a&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1c861a",
  null
  
)

export default component.exports